import angular from 'angular';
import 'angular-animate';
import ngCookies from 'angular-cookies';
import 'restangular';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'angular-ui-router-default';
import 'angular-ladda';
import 'ngstorage';
import 'angular-cookies';
import 'angular-breadcrumb';
import 'angular-google-maps';
import 'angular-simple-logger';
import 'angular-drag-and-drop-lists';
import 'angular-hotkeys';
import {permission, uiPermission} from 'angular-permission';
import ngInfiniteScroll from 'ng-infinite-scroll';
import 'app/services/growl';
import 'app/filters/datetime';
import 'app/filters/title';
import 'app/directives/ncybreadcrumb.title';


export function Module({name, inject, modules = [], setdefault = false}) {
    return Target => {

        if (angular.isDefined(name) && angular.isDefined(inject))
            throw new TypeError("Name and Inject can't be define in the same @Module");

        modules.push(...[
            ngCookies,
            'ui.router',
            'ui.router.default',
            'ui.bootstrap',
            'ui.select',
            'ngTable',
            'ngStorage',
            'angular-ladda',
            'ncy-angular-breadcrumb',
            'uiGmapgoogle-maps',
            'restangular',
            'ngAnimate',
            'ngCookies',
            'cfp.hotkeys',
            permission,
            uiPermission,
            ngInfiniteScroll,
            'dndLists',
            'app.growl',
            'app.filters.datetime',
            'app.filters.title',
            'app.directives.autofocus',
            'app.directives.loading',
            'app.directives.nodata',
            'app.directives.ncyBreadcrumbTitle',
            'app.directives.appLoading',
            'app.directives.check.browser',
            'app.directives.selectOnClick',
            'app.directives.uiSelectHelpers',
            'app.directives.read_only_icon',
            'app.helpers',
            'app.services.models.registry',
        ]);
        Target.$angularModule = angular.isUndefined(inject) ? angular.module(name, modules.map(extractAngularModuleName)) : extractAngularModule(inject);

        if (Target.component) Target.$angularModule.component(Target.$componentName, Target.component);
        if (Target.directive) Target.$angularModule.directive(Target.$directiveName, Target.directive);
        if (Target.$serviceName) Target.$angularModule.service(Target.$serviceName, Target);

        if (Target.$factories) {
            for (let factory of Target.$factories) {
                Target.$angularModule.factory(...factory);
            }
        }

        if (Target.$directives) {
            for (let d of Target.$directives) {
                Target.$angularModule.directive(...d);
            }
        }

        if (Target.stateConfigs) {
            Target.$angularModule.config(function($stateProvider) {
                "ngInject";
                for (let stateConfig of Target.stateConfigs) {
                    $stateProvider.state(...stateConfig);
                }
            });
        }

        for (let config of Target.$config || []) {
            Target.$angularModule.config(config);
        }

        for (let run of Target.$run || []) {
            Target.$angularModule.run(run);
        }
    };
}

export function Inject(...params) {
    return function(Target) {
        if (!Target.$inject) Target.$inject = [];
        Target.$inject = [...params, ...Target.$inject];
    };
}

export function State({name, as = 'vm', auth = true, ...params}) {
    return function (Target) {
        if (!Target.stateConfigs) Target.stateConfigs = [];
        let defaults = {
            auth: auth,
            controllerAs: as,
        };

        let state = angular.extend({}, params, defaults);

        if (state.views) {
            for (let key of Object.keys(state.views)) {
                let value = state.views[key];
                value.controllerAs = value.as || 'vm';
            }
        }
        Target.stateConfigs.push([name, state]);
    };
}

export function Component({as = '$ctrl', bindings = {}, selector, template = '', ...params}) {
    return Target => {
        if (!selector) throw new TypeError("A selector should be defined in the current annotation @Component");

        Target.$componentName = snakeCaseToCamelCase(selector);
        Target.component = {
            template: template,
            controller: Target,
            controllerAs: as,
            bindings: bindings,
            ...params,
        };
    };
}

export function Directive(name, method) {
    return Target => {
        if (!Target.$directives) Target.$directives = [];
        Target.$directives.push([snakeCaseToCamelCase(name), method]);
    };
}
export function Directive2({scope = true, as = 'vm', bindToController = true, selector, require = '', ...params}) {
    return Target => {
        if (!selector) throw new TypeError("A selector should be defined in the current annotation @Component");

        Target.$directiveName = snakeCaseToCamelCase(selector);
        Target.directive = () => {
            let ddo = {
                restrict: 'A',
                require: require,
                scope: scope,
                controller: Target,
                controllerAs: as,
                bindToController: bindToController,
            };
            angular.extend(ddo, params);

            Target.link && (ddo.link = Target.link);
            return ddo;
        };
    };
}


export function Service(name) {
    return Target => {
        Target.$serviceName = name;
    };
}

export function Factory(name, method) {
    return Target => {
        if (!Target.$factories) Target.$factories = [];
        Target.$factories.push([name, method]);
    };
}

export function Config(configFunction) {
    return Target => {
        if (!Target.$config) Target.$config = [];
        Target.$config.push(configFunction);
    };
}

export function Run(runFunction) {
    return (Target, name, descriptor) => {
        if (!Target.$run) Target.$run = [];
        Target.$run.push(runFunction || descriptor.value);
    };
}

export function Boot({element = document, strictDi = false}) {
    return Target => {
        if (!angular.isDefined(Target.$angularModule))
            throw new TypeError("@Boot should be used only on a @Module Class");

        angular.element(document).ready(() => angular.bootstrap(element, [Target.$angularModule.name], {strictDi: strictDi}));
    };
}

function snakeCaseToCamelCase(string) {
    return string.replace(/-([a-z])/ig, (_, letter) => letter.toUpperCase());
}

function extractAngularModuleName(clazz) {
    if (clazz.default) clazz = clazz.default;

    if (clazz.$angularModule)
        return clazz.$angularModule.name;

    return clazz.name ? clazz.name : clazz;
}

function extractAngularModule(clazz) {
    return clazz.$angularModule ? clazz.$angularModule : clazz;
}



// WEBPACK FOOTER //
// ./src/app/decorators.js